module.exports = __webpack_public_path__ + "static/IvarText-SemiBold-e8612504f356c8b0a541a4cb4ad48a12.woff2";